/**
 * TanStack Query client — shared across the app.
 *
 * Defaults are tuned for an ERP where data is moderately fresh:
 *   - staleTime 30s: refetch on window-focus only after 30s, so common
 *     within-page navigation reuses cached data without a network hit
 *   - retry 1: ERP endpoints are mostly authenticated reads; one retry
 *     for transient blips is enough, more would mask real errors
 *   - refetchOnWindowFocus disabled: too aggressive for ERP screens with
 *     many parallel queries; pages opt-in per-query when they need it
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
